import { Link } from "react-router-dom";
import { LOGO_URL } from "@/data/siteContent";

/** Crops the supplied AnyTribe logo PNG down to the wordmark. */
export function Logo({ className = "", height = 32, dark = false, testId = "brand-logo" }) {
  if (dark) {
    return (
      <span
        className={`font-display text-xl font-extrabold tracking-tight text-white ${className}`}
        data-testid={testId}
      >
        AnyTribe<span className="text-[#F2811D]">.</span>
        <span className="ml-1.5 align-middle text-[9px] font-bold tracking-[0.2em] text-white/60">
          MALAYSIA
        </span>
      </span>
    );
  }
  const scale = height / 97;
  return (
    <span
      className={`relative block overflow-hidden ${className}`}
      style={{ width: 429 * scale, height }}
      data-testid={testId}
    >
      <img
        src={LOGO_URL}
        alt="AnyTribe Marketing"
        className="absolute max-w-none select-none"
        style={{ width: 500 * scale, left: -31 * scale, top: -208 * scale }}
        draggable="false"
      />
    </span>
  );
}

export function LogoLink({ height = 32, dark = false }) {
  return (
    <Link to="/" aria-label="AnyTribe home" data-testid="brand-logo-link" className="inline-flex">
      <Logo height={height} dark={dark} />
    </Link>
  );
}
